import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarExtensionConfiguracion, obtenerExtensionConfiguracion, editarExtensionConfiguracion } from '../../../actions/configuracion';

const EditarExtension = ({ extension, reestablecerExtension }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.extensiones);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [extensionData, setExtensionData] = useState({
        id: null,
        nombre: null
    });

    /* Editar extension */
    const handleInputChange = ({ target }) => {
        setExtensionData({
            ...extensionData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(extensionData.nombre){
            await setStatusProcesar(true);
            await dispatch(editarExtensionConfiguracion(extensionData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setExtensionData({
                id: null,
                nombre: null
            });
            setEditarModal(false);
            reestablecerExtension(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarExtensionConfiguracion());
    }, []);

    useEffect(() => {
        if(extension){
            setEditarModal(true);
            
            dispatch(obtenerExtensionConfiguracion(extension?._id));

            setExtensionData({
                ...extensionData,
                id: extension?._id
            });
        }
    }, [extension]);

    useEffect(() => {
        if(detalles){
            setExtensionData({
                ...extensionData,
                id: detalles?._id, 
                nombre: detalles?.nombre
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} backdrop="static" size="md" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar extensión</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={extensionData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarExtension;